const emojiQuiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "emoji-quiz",
    items: [
      { id: "q1", question: "🎤☔ ", answers: ["ag canadh sa bháisteach"], image: null },
      { id: "q2", question: "🐍🐍✈️ ", answers: ["nathracha ar eitleán"], image: null },
      { id: "q3", question: "👻🔫 ", answers: ["sealgairí taibhse"], image: null },
      { id: "q4", question: "🐼👊 ", answers: ["kung fu panda"], image: null },
      { id: "q5", question: "🏃‍♂️📦🍫 ", answers: ["forrest gump"], image: null },
    ],
  },

  botId: "nualang.emoji-quiz.0.0.1",
  botName: "emoji_quiz",
  description: "emoji_quiz_desc",
  difficulty: "ALL",
  learnLang: "irish",
  name: "Líon Dracula",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwNi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-smile?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Fáilte go tráth na gceist na scannán
Óstáil ag Count Dracula.

An féidir leat na scannáin a léiríonn an emoji a ainmniú?
Léiríonn cuid acu teideal an scannáin, léiríonn cuid eile an plota.

Abair "Dia duit" chun Count Dracula a thosú.`,
  voice: "Joey",
};

export default emojiQuiz;
